module.exports = __webpack_public_path__ + "static/img/74 (4).536546e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/74 (4).jpg
// module id = MfME
// module chunks = 0